import { combineReducers } from 'redux'
import misc from './misc'
import oncall from './oncall'

export default combineReducers({
  misc,
  oncall,
})
